import { cloneDeep } from 'lodash'

import { toArray, getInt, getText, isDuplicate } from './common'

import {
  CheckListDetail,
  JobType,
  SubJobType,
} from 'features/checklist/auditRoad/types'

import { original } from 'features/checklist/auditRoad/reducer'

export const toCheckList = (data: string): any => {
  let checklist: CheckListDetail = cloneDeep(original)

  let mode = ''
  const rows = toArray(data)
  rows.forEach((row: any, index: number) => {
    const cmd = getText(row, 0).toLowerCase()
    switch (cmd) {
      case 'checklist name':
        mode = 'name'
        checklist.CheckListName = getText(row, 1)
        break

      case 'checklist type':
        mode = ''
        checklist.ProjectTypeID = getInt(row, 1)
        break

      case 'description':
        mode = 'description'
        addDefectDetail(checklist, row, index)
        break

      case 'note':
        mode = ''
        break

      case 'end':
        return checklist

      default:
        if (mode === 'description') addDefectDetail(checklist, row, index)
        else mode = ''

        break
    }
  })

  return checklist
}

const addDefectDetail = (
  checklist: CheckListDetail,
  row: string[],
  index: number
) => {
  const job = getText(row, 1)
  const subJob = getText(row, 2)
  const detail = getText(row, 3)
  const major = getText(row, 4)
  const supplier = getText(row, 5)
  const methodType = getInt(row, 6)

  if (detail === '') return

  let jobItem: JobType = {
    JobTypeID: 0,
    JobTypeName: job,
    SubJobTypeList: [],
    FixList: [],
  }

  if (job !== '') {
    jobItem.FixList = getFixList(row, 7, index)
    isDuplicate('JobTypeName', job, checklist.JobTypeList, index)
    checklist.JobTypeList.push(jobItem)
  }

  const jobIndex = checklist.JobTypeList.length - 1
  jobItem = checklist.JobTypeList[jobIndex]

  let subJobItem: SubJobType = {
    SubJobTypeID: 0,
    SubJobTypeName: subJob,
    DetailList: [],
  }

  if (subJob !== '') {
    isDuplicate('SubJobTypeName', subJob, jobItem.SubJobTypeList, index)
    jobItem.SubJobTypeList.push(subJobItem)
  }

  const subJobIndex = jobItem.SubJobTypeList.length - 1
  subJobItem = jobItem.SubJobTypeList[subJobIndex]

  const detailItem = {
    DetailID: 0,
    DetailName: detail,
    IsRequired: major === 'yes',
    IsSupplier: supplier === 'yes',
    MethodTypeID: methodType,
  }

  isDuplicate('DetailName', detail, subJobItem.DetailList, index)
  subJobItem.DetailList.push(detailItem)
}

const getFixList = (row: string[], start: number, index: number) => {
  const list: any[] = []
  const len = row.length
  for (let i = start; i < len; i++) {
    const code = getText(row, i)
    if (code === '') return list

    isDuplicate('FixName', code, list, index)
    list.push({
      FixID: 0,
      FixName: code,
    })
  }

  return list
}
